import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

import { useNavigate } from "hooks";
import { ReactComponent as ExpiredLink } from "../../assets/icons/expired-link.svg";

export const ExpiredDirectLogin: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Stack sx={{ bgcolor: "#f5f7f7", width: "100vw", height: "100vh" }} direction="row">
      <Box sx={{ bgcolor: "#173c4c", maxWidth: "30%", minWidth: "30%" }} />
      <Stack sx={{ flexGrow: 1, p: "30px 25px 5px 110px", gap: "10px" }}>
        <Typography
          sx={{
            color: "#173c4c",
            fontFamily: "Oswald, sans-serif",
            fontSize: "2.5rem",
            fontWeight: 300,
            letterSpacing: "1.25px",
            lineHeight: "60px"
          }}
        >
          Direct login link
        </Typography>
        <ExpiredLink />
        <Typography>Direct login link access expires after 24 hours.</Typography>
        <Stack
          direction="row"
          sx={{ gap: "8px", cursor: "pointer", alignSelf: "flex-start" }}
          onClick={() => navigate({ route: "login" })}
        >
          <ArrowCircleDownIcon sx={{ transform: "rotate(90deg)" }} />
          <Typography sx={{ color: "#173c4c" }}>Go back to main login</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
